import React from "react";
import { useTranslation } from "react-i18next";
import { BarChart2 } from "lucide-react";
import MarketOverviewD3 from "./MarketOverview";

/**
 * Extracted verbatim from UnifiedStockerDashboard.jsx. MarketOverviewD3 used
 * to render through hardcoded dark-palette color constants only (inline
 * styles, not Tailwind dark: classes), so this wrapper was kept
 * unconditionally dark to avoid a dark chart on a light card (found by the
 * pass-28 accessibility sweep). 2026-09-11: MarketOverview.jsx's inline
 * palette is now theme-aware (DARK_C/LIGHT_C, switched via useTheme()), so
 * this wrapper can finally take a real light variant too.
 */
const MarketOverviewSection = ({ data, isLoading, indexesExtraData, onSubChange }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 sm:mb-6 bg-cream-100 dark:bg-slate-900/60 border border-cream-300 dark:border-slate-800/60 rounded-xl p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-3">
        <BarChart2 className="w-4 h-4 text-blue-700 dark:text-blue-400" />
        <h2 className="text-sm font-bold text-cream-900 dark:text-slate-200">{t("dashboard.unifiedDashboard.marketOverview")}</h2>
        <span className="text-[10px] text-cream-700 dark:text-slate-500 ml-1">{t("dashboard.unifiedDashboard.liveMarketData")}</span>
      </div>

      <MarketOverviewD3
        data={data}
        isLoading={isLoading}
        indexesExtraData={indexesExtraData}
        onSubChange={onSubChange}
      />
    </div>
  );
};

export default MarketOverviewSection;
